import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DocsRequests } from 'src/requests/docs';

export const useDeletePemanentlyDocMutation = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: deletePermanentlyDoc, isLoading: isDeletingDoc } =
    useMutation((id: string) => DocsRequests.deleteDocFromTrash(id), {
      onSuccess() {
        queryClient.invalidateQueries(['docsTrash']);
      },
    });

  return {
    deletePermanentlyDoc,
    isDeletingDoc,
  };
};
